import { EyeIcon, LockIcon } from "melco-ui";
import { useState } from "react";
import styled from "styled-components";
type EmailFieldType = {
    email:string;
}

const EmailWrapper = styled.span`
border:1px solid #e5e3e3;
width:80%;
border-radius:3px;
padding:3px;
`;

const IconWrapper = styled.span`
margin: 0px 5px;
` 
export const EmailField: React.FC<EmailFieldType> = ({ email }) => {
    const [type, setType]=useState('password');
    return (<>
                <EmailWrapper>
                    {type==="password"?"********************":email}
                    {type==='password'  && <IconWrapper><EyeIcon   onClick={(e)=> {
                    type==='password'?setType('text'):setType('password');
                    }
                    
                    }
                    />
                    </IconWrapper>}

                    {type!=='password' && <IconWrapper><LockIcon  onClick={(e)=> {
                        type==='password'?setType('text'):setType('password');
                        } 
                    }
                    />
                    </IconWrapper>}
                </EmailWrapper>
              
            {/* {type==="password"?email.replace(/(\w{3})[\w.-]+@([\w.]+\w)/, "$1*******@$2"):email}  */}
                     

    </>)
};